window.getGroundTransit = async function getGroundTransit(zip) {
  const url = document.getElementById("popup").dataset.source
  const response = await fetch(url, { cache: "force-cache" })
  if (!response.ok) throw new Error(`Zip Database status: ${response.status}`)
  const database = await response.json()
  const data_key = database.mappings[zip]
  if (!data_key) {
    console.error(`[getGroundTransit] missing ZIP: ${zip}`)
    return
  }
  const data = database["groups"][data_key]
  data["destination_zip"] = zip
  return data
}
